import axios from 'axios'

export default {

    getBusinessTurnoverList({commit}, params){
        return axios.post('/api/background/business_info/list', params)
    },
    getBusinessSummary({commit}, params){
        return axios.post('/api/background/business_summary/get', params)
    },
    getIndexTurnoverList({commit}, params){
        return axios.post('/api/background/business_info/repast/list', params)
    },
}


// WEBPACK FOOTER //
// ./src/vuex/actions/turnover.js